/* cookit Herbst 2026 – Warenkorb, Öffnungszeiten, PLZ-Check */
(function () {
  'use strict';
  var MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var DAYS = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];

  /* ---------- Zeit in Bonn ---------- */
  function berlin() {
    var now = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hourCycle: 'h23', weekday: 'short'
      }).formatToParts(now);
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour, min: +o.minute, wd: wdMap[o.weekday] };
    } catch (e) {
      return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate(), h: now.getHours(), min: now.getMinutes(), wd: now.getDay() };
    }
  }
  var B = berlin();
  var W = B.wd * 1440 + B.h * 60 + B.min; // Minute der Woche ab Sonntag 0 Uhr
  var OPEN = (window.ckOpenMinute != null) ? window.ckOpenMinute : 600; // Sonntag 10 Uhr

  function dateOf(offsetDays) {
    // Datum (Bonn) = heute + offsetDays, rein über UTC-Rechnung ohne Zeitzonenfehler
    var t = Date.UTC(B.y, B.m - 1, B.d) + offsetDays * 86400000;
    var x = new Date(t);
    return { d: x.getUTCDate(), m: x.getUTCMonth(), y: x.getUTCFullYear(), wd: x.getUTCDay() };
  }
  function slotState(close, end, wd) {
    // liefert {open:bool, reason:'preopen'|'running'|'over'}
    if (W < OPEN) return { open: false, reason: 'preopen' };
    if (W < close) return { open: true };
    if (end && B.wd === wd && (B.h * 60 + B.min) < end) return { open: false, reason: 'running' };
    return { open: false, reason: 'over' };
  }
  window.ckSlotState = slotState;

  /* ---------- KW-Zeile ---------- */
  function isoWeek(y, m, d) {
    var t = new Date(Date.UTC(y, m, d));
    var day = t.getUTCDay() || 7;
    t.setUTCDate(t.getUTCDate() + 4 - day);
    var y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - y0) / 86400000 + 1) / 7);
  }
  var start = dateOf(-B.wd), end = dateOf(6 - B.wd);
  var mon = dateOf(1 - B.wd);
  var kw = isoWeek(mon.y, mon.m, mon.d);
  var range = start.m === end.m
    ? start.d + '.–' + end.d + '. ' + MONTHS[end.m]
    : start.d + '. ' + MONTHS[start.m] + ' – ' + end.d + '. ' + MONTHS[end.m];
  document.querySelectorAll('[data-ck-kw]').forEach(function (el) { el.textContent = 'KW ' + kw; });
  document.querySelectorAll('[data-ck-range]').forEach(function (el) { el.textContent = range; });

  /* ---------- Bestellseiten und Übersicht ---------- */
  document.querySelectorAll('[data-ck-slot]').forEach(function (el) {
    var mode = el.getAttribute('data-mode') || 'auto';
    var close = +el.getAttribute('data-close'), end = +el.getAttribute('data-end'), wd = +el.getAttribute('data-wd');
    var st = mode === 'open' ? { open: true } : mode === 'closed' ? { open: false, reason: 'manual' } : slotState(close, end, wd);
    el.setAttribute('data-state', st.open ? 'open' : 'closed');
    el.setAttribute('data-reason', st.reason || '');
    // Datum des Slot-Tages in der laufenden Woche
    var dt = dateOf(wd - B.wd);
    el.querySelectorAll('[data-ck-date]').forEach(function (n) { n.textContent = DAYS[wd] + ', ' + dt.d + '. ' + MONTHS[dt.m]; });
    // Seite: offen/zu
    var openEl = el.querySelector('.order-open'), closedEl = el.querySelector('.order-closed');
    if (openEl && closedEl) {
      openEl.hidden = !st.open; closedEl.hidden = st.open;
      closedEl.querySelectorAll('[data-reason-box]').forEach(function (b) {
        var r = b.getAttribute('data-reason-box');
        b.hidden = !(r === st.reason || (r === 'over' && (st.reason === 'manual')));
      });
    }
    // Übersicht: Status-Text
    el.querySelectorAll('[data-ck-status]').forEach(function (n) {
      if (st.open) { n.textContent = n.getAttribute('data-open-text') || 'Vorbestellung offen'; n.setAttribute('data-state', 'open'); }
      else if (st.reason === 'preopen') { n.textContent = 'ab heute 10 Uhr'; n.setAttribute('data-state', 'closed'); }
      else { n.textContent = 'diese Woche zu'; n.setAttribute('data-state', 'closed'); }
    });
    if (!st.open) el.classList.add('is-closed'); else el.classList.remove('is-closed');
  });

  /* ---------- Zahlenformat ---------- */
  function eur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* ---------- Warenkorb ---------- */
  var toast;
  function showToast(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ck-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML = '<span></span><a href="/cart">Zum Warenkorb</a>';
      document.body.appendChild(toast);
    }
    toast.querySelector('span').textContent = text;
    toast.classList.add('on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('on'); }, 4200);
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-ck-count]').forEach(function (n) { n.textContent = cart.item_count; n.setAttribute('data-count', cart.item_count); });
      document.querySelectorAll('[data-ck-bar]').forEach(function (bar) {
        if (cart.item_count > 0) {
          bar.querySelector('[data-bar-n]').textContent = cart.item_count + ' im Warenkorb';
          bar.querySelector('[data-bar-sum]').textContent = eur(cart.total_price);
          bar.classList.add('on');
          if (window.matchMedia('(max-width: 820px)').matches) document.body.style.paddingBottom = (bar.offsetHeight || 76) + 'px';
        } else { bar.classList.remove('on'); document.body.style.paddingBottom = ''; }
      });
      return cart;
    }).catch(function () {});
  }
  window.ckRefreshCart = refreshCart;

  function updateButton(form) {
    var btn = form.querySelector('[data-add-btn]');
    var r = form.querySelector('input[name="id"]:checked');
    var q = form.querySelector('input[name="quantity"]');
    if (!btn || btn.hasAttribute('data-soldout')) return;
    var base = btn.getAttribute('data-label') || 'In den Warenkorb';
    if (r && r.getAttribute('data-price') && btn.hasAttribute('data-show-price')) {
      var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      btn.textContent = base + ' · ' + eur(+r.getAttribute('data-price') * qty);
    } else btn.textContent = base;
  }

  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('form[data-ck-add]');
    if (f) updateButton(f);
    // Hybrid-Umschalter
    if (e.target.matches && e.target.matches('[data-hy-switch]')) {
      var card = e.target.closest('[data-hy]');
      card.querySelectorAll('[data-hy-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-hy-pane') !== e.target.value; });
    }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qty]');
    if (b) {
      var input = b.parentNode.querySelector('input[name="quantity"]');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + (+b.getAttribute('data-qty')));
      input.value = Math.min(v, 99);
      var f = b.closest('form[data-ck-add]'); if (f) updateButton(f);
    }
    // Galerie
    var th = e.target.closest && e.target.closest('[data-thumb]');
    if (th) {
      var main = document.querySelector('[data-gal-main] img');
      if (main) { main.src = th.getAttribute('data-thumb'); main.removeAttribute('srcset'); }
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('on', t === th); });
    }
    // Mobilmenü schliessen bei Link-Klick
    var ml = e.target.closest && e.target.closest('.mnav-panel a');
    if (ml) { var d = ml.closest('details'); if (d) d.removeAttribute('open'); }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ck-add]')) return;
    if (!window.fetch || !window.FormData) return; // normaler Versand
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var msg = form.querySelector('.msg');
    if (msg) msg.textContent = '';
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) { if (msg) msg.textContent = (res.j && (res.j.description || res.j.message)) || 'Das hat leider nicht geklappt. Bitte nochmal versuchen.'; return; }
        var name = form.getAttribute('data-name') || 'Kochtüte';
        var v = form.querySelector('input[name="id"]:checked');
        var lbl = v ? (v.getAttribute('data-label') || '') : '';
        var qn = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
        showToast((qn > 1 ? qn + ' × ' : '') + (lbl ? lbl + ' · ' : '') + name + (qn > 1 ? ' liegen' : ' liegt') + ' im Warenkorb');
        refreshCart();
      })
      .catch(function () { if (btn) btn.disabled = false; form.submit(); });
  });
  document.querySelectorAll('form[data-ck-add]').forEach(updateButton);
  if (document.querySelector('[data-ck-bar]')) refreshCart();

  /* ---------- PLZ-Check ---------- */
  document.querySelectorAll('[data-ck-plz]').forEach(function (box) {
    var data = {};
    try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) {}
    var input = box.querySelector('input'), btn = box.querySelector('button'), out = box.querySelector('[data-plz-out]');
    function check() {
      var v = (input.value || '').replace(/\D/g, '').slice(0, 5);
      if (v.length !== 5) { out.hidden = false; out.className = 'res no'; out.innerHTML = '<span>Bitte eine fünfstellige Postleitzahl eingeben.</span>'; return; }
      var hits = (data.tours || []).filter(function (t) { return t.plz.indexOf(v) > -1; });
      out.hidden = false;
      if (!hits.length) {
        out.className = 'res no';
        out.innerHTML = '<span><b>' + v + ':</b> Dorthin liefern wir leider noch nicht. Hol deine Kochtüte gern am Markt ab – Bonn oder Siegburg.</span>';
        return;
      }
      out.className = 'res';
      var t = hits.map(function (h) { return h.name; }).join(' und ');
      var html = '<span><b>' + v + ':</b> Wir liefern zu dir – ' + t + '.<span class="resbtns">';
      hits.forEach(function (h) { html += '<a class="btn sm" href="' + h.url + '">' + h.btn + '</a>'; });
      out.innerHTML = html + '</span></span>';
    }
    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
  });


  /* ---------- Zähler aktuell halten, wenn der Warenkorb (Dawn) Mengen ändert ---------- */
  (function () {
    var bub = document.getElementById('cart-icon-bubble');
    if (!bub || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refreshCart, 150); }).observe(bub, { childList: true, subtree: true, characterData: true });
  })();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- Kopfhöhe fürs Mobilmenü ---------- */
  function hdrH() {
    var h = document.getElementById('shopify-section-ck-header');
    var a = document.getElementById('shopify-section-ck-announcement');
    if (h) document.documentElement.style.setProperty('--ck-hdr-h', (h.getBoundingClientRect().bottom) + 'px');
  }
  hdrH(); window.addEventListener('resize', hdrH); window.addEventListener('scroll', hdrH, { passive: true });
})();
